import React, { Fragment } from 'react'
import { copyToClipboard } from 'utils/helpers'

// third party components
import { Menu, Transition } from '@headlessui/react'

// images and icons
import ThreeDotIcon from 'assets/icons/three-dot-icon-16x4.svg?component'

// styles
import styles from './index.module.scss'
import MenuEditMerchPage from '../MenuEditMerchPage'

interface MenuEditProps {
  isCreatedMerch: boolean
  setShowEditMerch: any
  setOpenShareModal: any
  showDownloadMockups: boolean
  downloadFiles: any
}

const MenuEditMerch = ({
  isCreatedMerch,
  setShowEditMerch,
  setOpenShareModal,
  showDownloadMockups,
  downloadFiles,
}: MenuEditProps) => {
  return (
    <div className="relative flex items-center">
      <Menu>
        <Menu.Button>
          <div className={`${styles.iconContainer} w-[30px] h-[30px]`}>
            <ThreeDotIcon alt="" />
          </div>
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Item>
            {({ active }) => (
              <div>
                <MenuEditMerchPage
                  setShowEditMerch={setShowEditMerch}
                  isCreatedMerch={isCreatedMerch}
                  setOpenShareModal={setOpenShareModal}
                  showDownloadMockups={showDownloadMockups}
                  downloadFiles={downloadFiles}
                />
              </div>
            )}
          </Menu.Item>
        </Transition>
      </Menu>
    </div>
  )
}

export default MenuEditMerch
